import { render } from "./App.vue?vue&type=template&id=ca3bd518"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ca3bd518&lang=scss"

import exportComponent from "/Users/howard/Repos/the-last-word/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__